<template>
  <div class="product-review-text-wrap" :class="images.length > 1 ? ' wide' : ''">
    <div class="product-review-text">
        <div>
            {{ result.UF_COMMENT }}
        </div>

        <DefLink class="product-review-text__response" :data-review-id="result.ID">
            {{ messages.response }}
        </DefLink>


    </div>

    <div class="product-review-img" v-if="images.length > 0">
      <img
          v-for="image in images"
          alt="review image"
          :data-fancybox="result.ID"
          :src="image" />
    </div>
  </div>
</template>

<script>
    import DefLink from "../../Def/DefLink/DefLink.vue";

    export default {
        name: "ProductReviewText",
        components: {DefLink},
        props: ['result', 'messages', 'user'],
        computed: {
          images() {
            if(!Object.keys(this.result?.UF_PHOTO).length)
              return false

            return Object.keys(this.result.UF_PHOTO).map(key => (this.result.UF_PHOTO[key]))
          }
        },
        methods: {
            /**
             * через @click не получилось - в стеке есть уже обработчики завешенные на document
             * @param e
             */
            addReview(e) {
                if (e.target.classList.contains("product-review-text__response")) {
                    let reviewID = e.target.getAttribute('data-review-id');
                    if (this.result.ID == reviewID) {
                        this.$emit('openReviewModal', this.result);
                    }
                }
            },

        },
        mounted() {
            document.addEventListener('click', this.addReview);
            const fancyboxReview = new Fancybox.bind('[data-fancybox ^= "review-images_"]', {
              Image: {
                Panzoom: {
                  maxScale: 3
                }
              }
            });
        },
        beforeUnmount() {
            document.removeEventListener('click', this.addReview);
        },
    }
</script>

<style lang="scss" scoped>
    .product-review-text-wrap:not(.wide),
    .product-review-text-wrap.wide .product-review-img {
      display: flex;
    }
    .product-review-text-wrap.wide .product-review-img img {
      margin-right: 5px;
    }
    .product-review-img {
      margin-top: 7px;
    }
    .product-review-img img {
      max-height: 120px;
      cursor: pointer;
    }
    .product-review-text {
        width: 100%;
        font-family: Montserrat, sans-serif;
        font-size: 13px;

        > div {
            margin-bottom: 10px;
        }

        :deep(.def-link) {
            color: #faa295;
        }
    }
</style>